import type { FC } from 'react'

const OnboardingRelatedView: FC = () => {
  return <></>
}

export default OnboardingRelatedView
